import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  buttonLoading: false,
  data: null,
};

export const landingSlice = createSlice({
  name: "landing",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setButtonLoading: (state, action) => {
      state.buttonLoading = action.payload;
    },
    setLandingData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setLoading, setButtonLoading, setLandingData } =
  landingSlice.actions;

export default landingSlice.reducer;
